module.exports = __webpack_public_path__ + "img/cs-banner-back.b97b75be.png";